/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import $ from 'jquery';

import icons from '../data/icons';

class Preloader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLogo: false,
            hide: false
        };

        this.eventShowLogo = this.eventShowLogo.bind(this);
        this.closePreloader = this.closePreloader.bind(this);
        this.eventTransitionEndPreloader = this.eventTransitionEndPreloader.bind(this);
        this.mounted = false;
        this.timer = null;
    }

    componentDidMount() {
        this.mounted = true;
        window.requestAnimationFrame(this.eventShowLogo);

        this.timer = setTimeout(this.closePreloader, 3000);
        $('.preloader').on('transitionend', this.eventTransitionEndPreloader);
    }

    componentWillUnmount() {
        this.mounted = false;

        clearTimeout(this.timer);
        $('.preloader').off('transitionend', this.eventTransitionEndPreloader);
    }

    eventShowLogo() {
        if (this.mounted) {
            this.setState({ showLogo: true });
        }
    }

    closePreloader() {
        if (this.mounted) {
            if (!this.state.hide) {
                clearTimeout(this.timer);
                this.setState({ hide: true });
            }
        }
    }

    eventTransitionEndPreloader(e) {
        if (this.mounted && $(e.target).hasClass('preloader')) {
            $('.preloader').off('transitionend', this.eventTransitionEndPreloader);
            this.props.preloaderFinished();
        }
    }

    render() {
        const { showLogo, hide } = this.state;
        const { noTransition, claim } = this.props;

        const letters = [];
        for (let i = 1; i <= 7; i += 1) {
            const className = cx(`svg-${ i }`, { 'no-transition': noTransition });
            const icon = `letter${ i }`;
            letters.push((
                <span
                  className={ className }
                  dangerouslySetInnerHTML={ { __html: icons.preloader[icon] } }
                  key={ icon }
                />
            ));
        }

        return (
            <div className={ cx('preloader', { hide }) }>
                <div className={ cx('preloader-box', { show: showLogo }) }>
                    { letters }
                    <div className="preloader-logo-text" >
                        <div dangerouslySetInnerHTML={ { __html: claim } }/>
                    </div>
                </div>
            </div>
        );
    }
}

Preloader.defaultProps = {
    claim: 'legal and technical support for your cybersecurity'
};

Preloader.propTypes = {
    preloaderFinished: PropTypes.func.isRequired,
    noTransition: PropTypes.bool.isRequired,
    claim: PropTypes.string
};

export default Preloader;



// WEBPACK FOOTER //
// ./src/components/Preloader.jsx